var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.validated)?_c('base-icon',{staticClass:"mr-1 text-green-500",attrs:{"name":"check","size":"sm"}}):_c('base-icon',{staticClass:"mr-1 text-red-500",attrs:{"name":"cross","size":"sm"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }